<template lang="pug">
  // アカウント作成完了画面
  #create-execute
    HeaderForLogin
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      b-card.mt-4.text-center.mx-auto.body-width.pb-2(header-tag="header")
        .capiton-box.mx-auto
          // カード内の文言表示
          p.mt-3.white-space {{text_content}}
          router-link.mb-3.d-inline-flex(:to="{name: 'Login'}") ログイン画面へ
</template>

<script>
import Api from "@/repositories/api"
import Loading from '@/components/Loading';
import HeaderForLogin from "@/components/supportSite/HeaderForLogin";

const S209CreateAccount = Api.get("s209CreateAccount")

export default {
  name: "CreateExecute",
  components: {
    Loading,
    HeaderForLogin
  },
  data() {
    return {
      text_content: "クラウド版サポートサイトのアカウント作成が完了しました\n"
          + "下記リンクからログインしてください\n"
    }
  },
  created() {
    // ローディング表示
    this.isLoading = true;

    // クエリパラメータのトークンを引数に設定して、アカウント作成実行処理呼び出し
    S209CreateAccount.create(this.$route.query.token)
    // 処理成功
    .then(() => {
      // 何もしない
    })
    // 処理失敗
    .catch((error) => {
      // 共通のエラー処理
      this.apiError(error, "登録処理");

      // エラー用の画面へ遷移する
      this.$router.push({
        name: "RelatedPasswordSetting",
        params: {
          // 画面に表示するエラーメッセージ
          error_msg:error.response.data.error_list[0].error_msg
        }
      })
    })
    .finally(() => {
      // ローディング表示終了
      this.isLoading = false;
    })
  }
}
</script>

<style scoped>
.body-width {
  max-width: 1200px;
}
.capiton-box {
  max-width: 600px;
}
.white-space {
  white-space: pre-wrap;
}
</style>